import React from "react";
import Sidebar from "../Admin/Sidebar";

const banners = [
  {
    id: 1,
    title: "Homepage Banner",
    image: "https://via.placeholder.com/150",
    position: "Top",
    status: "Active",
    createdAt: "2026-01-20",
  },
  {
    id: 2,
    title: "Promotion Banner",
    image: "https://via.placeholder.com/150",
    position: "Middle",
    status: "Inactive",
    createdAt: "2026-01-18",
  },
];

function ViewBanner() {
  return (
    <div className="flex min-h-screen bg-gray-100">
      {/* Sidebar */}
      

      {/* Main Content */}
      <div className="flex-1 p-6 ml-8 lg:ml-24">
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold text-gray-800">
            View Banners
          </h1>
          <button className="bg-violet-500 text-white px-4 py-2 rounded-lg hover:bg-violet-600">
            + Add Banner
          </button>
        </div>

        {/* Table */}
        <div className="bg-white rounded-xl shadow overflow-x-auto">
          <table className="w-full text-sm text-left">
            <thead className="bg-gray-100 text-gray-700 uppercase">
              <tr>
                <th className="px-6 py-3">#</th>
                <th className="px-6 py-3">Title</th>
                <th className="px-6 py-3">Image</th>
                <th className="px-6 py-3">Position</th>
                <th className="px-6 py-3">Status</th>
                <th className="px-6 py-3">Created At</th>
                <th className="px-6 py-3 text-center">Actions</th>
              </tr>
            </thead>

            <tbody>
              {banners.map((banner, index) => (
                <tr
                  key={banner.id}
                  className="border-b hover:bg-gray-50 text-teal-400"
                >
                  <td className="px-6 py-4">{index + 1}</td>
                  <td className="px-6 py-4 font-medium text-teal-400">
                    {banner.title}
                  </td>
                  <td className="px-6 py-4">
                    <img
                      src={banner.image}
                      alt={banner.title}
                      className="w-20 h-12 object-cover rounded"
                    />
                  </td>
                  <td className="px-6 py-4">
                    {banner.position}
                  </td>
                  <td className="px-6 py-4">
                    <span
                      className={`px-3 py-1 rounded-full text-xs font-semibold ${
                        banner.status === "Active"
                          ? "bg-green-100 text-green-700"
                          : "bg-red-100 text-red-700"
                      }`}
                    >
                      {banner.status}
                    </span>
                  </td>
                  <td className="px-6 py-4">
                    {banner.createdAt}
                  </td>
                  <td className="px-6 py-4 text-center space-x-2">
                    <button className="text-blue-600 hover:underline">
                      Edit
                    </button>
                    <button className="text-red-600 hover:underline">
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default ViewBanner;
